import {
  SCOOTER_TRIP_LOADING,
  SCOOTER_TRIP_ERROR,

  SCOOTER_TRIP_LIST,
  SCOOTER_TRIP_PATH,
  SCOOTER_TRIP_UPDATE
} from "actions/scooter/trip/constants";

const initialState = {
  loading: false,
  errors: [],

  list: {
    content: []
  },
  path: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SCOOTER_TRIP_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case SCOOTER_TRIP_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case SCOOTER_TRIP_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case SCOOTER_TRIP_PATH:
      return {
        ...state,
        loading: false,
        errors: [],
        path: action.payload,
      };
    case SCOOTER_TRIP_UPDATE:
      // eslint-disable-next-line no-case-declarations
      const index = state.list.content.findIndex(i => i.id === action.payload.id);
      // eslint-disable-next-line no-case-declarations
      const content = [...state.list.content];
      content[index] = action.payload;
      return {
        ...state,
        loading: false,
        errors: [],
        list: {
          ...state.list,
          content
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooterTripReducer.js